'use strict';exports.__esModule = true;var _react = require('react');var _react2 = _interopRequireDefault(_react);
var _propTypes = require('prop-types');var _propTypes2 = _interopRequireDefault(_propTypes);
var _reactRedux = require('react-redux');
var _reduxPagan = require('redux-pagan');
var _components = require('../../components');

var _RealtorAdditionalPromotionContainer = require('./RealtorAdditionalPromotionContainer.scss');var styles = _interopRequireWildcard(_RealtorAdditionalPromotionContainer);
var _packagesConfigs = require('../RealtorPackagesContainer/packagesConfigs');
var _RealtorAdditionalPromotion = require('../../components/RealtorAdditionalPromotion/RealtorAdditionalPromotion');function _interopRequireWildcard(obj) {if (obj && obj.__esModule) {return obj;} else {var newObj = {};if (obj != null) {for (var key in obj) {if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];}}newObj.default = obj;return newObj;}}function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}function _classCallCheck(instance, Constructor) {if (!(instance instanceof Constructor)) {throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self, call) {if (!self) {throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call && (typeof call === "object" || typeof call === "function") ? call : self;}function _inherits(subClass, superClass) {if (typeof superClass !== "function" && superClass !== null) {throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);}subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;}

var promotions = [
{
  type: _packagesConfigs.PROMOTIONS.AUTO_JUMPS,
  description: _packagesConfigs.PROMOTIONS.AUTO_JUMPS + 'PromoDescription',
  price: 5,
  theme: _RealtorAdditionalPromotion.ADDITIONAL_PROMO_THEMES.GREEN },

{
  type: _packagesConfigs.PROMOTIONS.HIGHLIGHTS,
  description: _packagesConfigs.PROMOTIONS.HIGHLIGHTS + 'PromoDescription',
  price: 79,
  theme: _RealtorAdditionalPromotion.ADDITIONAL_PROMO_THEMES.PINK },

{
  type: _packagesConfigs.PROMOTIONS.TOP_AD,
  description: _packagesConfigs.PROMOTIONS.TOP_AD + 'PromoDescription',
  price: 255,
  theme: _RealtorAdditionalPromotion.ADDITIONAL_PROMO_THEMES.ORANGE }];var



RealtorAdditionalPromotionContainer = function (_Component) {_inherits(RealtorAdditionalPromotionContainer, _Component);function RealtorAdditionalPromotionContainer() {var _temp, _this, _ret;_classCallCheck(this, RealtorAdditionalPromotionContainer);for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {args[_key] = arguments[_key];}return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.
    renderPromotion = function (promotion) {return (
        _react2.default.createElement(_components.RealtorAdditionalPromotion, {
          key: promotion.type,
          theme: promotion.theme,
          title: _this.props.translate(promotion.type + 'AdTitle').toString(),
          description: _this.props.translate(promotion.description).toString(),
          buttonTitle: _this.props.translate('addForOnly').toString(),
          price: promotion.price }));}, _temp), _possibleConstructorReturn(_this, _ret);}RealtorAdditionalPromotionContainer.prototype.



  render = function render() {
    return (
      _react2.default.createElement('div', { className: styles.promotions },
        promotions.map(this.renderPromotion)));


  };return RealtorAdditionalPromotionContainer;}(_react.Component);


RealtorAdditionalPromotionContainer.propTypes = {
  translate: _propTypes2.default.func,
  packagesTranslate: _propTypes2.default.func,
  locale: _propTypes2.default.string,
  isMobile: _propTypes2.default.bool };


var mapStateToProps = function mapStateToProps(state) {return {
    translate: (0, _reduxPagan.getLang)(state.lang, 'AdditionalPromotions'),
    packagesTranslate: (0, _reduxPagan.getLang)(state.lang, 'PublishProperty'),
    locale: state.lang.locale,
    isMobile: state.windowDimentions.isMobile };};exports.default =


(0, _reactRedux.connect)(mapStateToProps)(
RealtorAdditionalPromotionContainer);module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/containers/RealtorAdditionalPromotionContainer/RealtorAdditionalPromotionContainer.js
// module id = 3016
// module chunks = 0